import { Grid, Typography } from "@mui/material"
import { FormikSwitch, FormikTextField } from "../../../../../../shared/components/forms/Formik"
import { StandardMainPanel } from "../../../../../../shared/components/forms/StandardMainPanel"
import { StandardSidePanel } from "../../../../../../shared/components/forms/StandardSidePanel"
import { StandardForm } from "../../../../../../shared/components/forms/StandardForm"
import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"
import { CreateUpdateDepartment, HistoryType } from "../departmentsTypes"
import { useDateTime } from "../../../../../localization/useDateTime"

type CreateUpdateDepartmentFormContentProps = Readonly<{
    history?: HistoryType
}>

export function CreateUpdateDepartmentFormContent({ history }: CreateUpdateDepartmentFormContentProps) {
    const dateTimeFactory = useDateTime()

    return (
        <>
            <StandardForm>
                <StandardMainPanel>
                    <LocalizedStrict
                        id="create-or-edit-company-department-field-departmentNo"
                        attrs={{ label: true, placeholder: true }}
                    >
                        <FormikTextField
                            name="departmentNo"
                            label="Department no."
                            placeholder="Enter Department no."
                            fullWidth
                        />
                    </LocalizedStrict>
                    <LocalizedStrict
                        id="create-or-edit-company-department-field-name"
                        attrs={{ label: true, placeholder: true }}
                    >
                        <FormikTextField name="name" label="Name" placeholder="Enter name" fullWidth />
                    </LocalizedStrict>
                </StandardMainPanel>
                <LocalizedStrict id="create-or-edit-company-department-settings" attrs={{ title: true }}>
                    <StandardSidePanel title="Settings" variant="collapsible">
                        <LocalizedStrict id="create-or-edit-company-department-field-active">
                            <FormikSwitch<CreateUpdateDepartment> name="isActive">Active</FormikSwitch>
                        </LocalizedStrict>
                    </StandardSidePanel>
                </LocalizedStrict>
                {history && (
                    <LocalizedStrict id="create-or-edit-company-department-history" attrs={{ title: true }}>
                        <StandardSidePanel title="History" variant="collapsible">
                            <Grid container item>
                                <Grid item xs={12} sm={5} justifyContent="space-between">
                                    <LocalizedStrict id="history-created">
                                        <Typography variant="body2">Created:</Typography>
                                    </LocalizedStrict>
                                </Grid>
                                <Grid item xs={12} sm={7}>
                                    <Typography variant="body2" textAlign="right">
                                        {dateTimeFactory.formatDateTime(
                                            dateTimeFactory.fromApi(history.created.timestamp),
                                        )}
                                    </Typography>
                                    <Typography variant="body2" textAlign="right">
                                        {history.created.author ?? "-"}
                                    </Typography>
                                </Grid>
                            </Grid>
                            <Grid container item>
                                <Grid item xs={12} sm={5}>
                                    <LocalizedStrict id="history-edited">
                                        <Typography variant="body2">Edited:</Typography>
                                    </LocalizedStrict>
                                </Grid>
                                <Grid item xs={12} sm={7}>
                                    <Typography variant="body2" textAlign="right">
                                        {history.updated
                                            ? dateTimeFactory.formatDateTime(
                                                  dateTimeFactory.fromApi(history.updated.timestamp),
                                              )
                                            : "-"}
                                    </Typography>
                                    <Typography variant="body2" textAlign="right">
                                        {history.updated?.author ?? "-"}
                                    </Typography>
                                </Grid>
                            </Grid>
                        </StandardSidePanel>
                    </LocalizedStrict>
                )}
            </StandardForm>
        </>
    )
}
